import React, { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const isTokenValid = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Date.now() / 1000;
    return payload.exp && payload.exp > now;
  } catch (e) {
    console.warn('Token inválido ou malformado:', e);
    return false;
  }
};

// LER id_bpo DO JWT
const getIdBpoFromToken = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.id_bpo !== undefined ? payload.id_bpo : null;
  } catch (e) {
    return null;
  }
};

const PrivateRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isCliente, setIsCliente] = useState(false);
  const location = useLocation();
  const token = localStorage.getItem('access');

  useEffect(() => {
    verificarTipoUsuario();
  }, []);

  const verificarTipoUsuario = async () => {
    if (!token || !isTokenValid(token)) {
      setIsCliente(false);
      setLoading(false);
      return;
    }

    // LER id_bpo DO JWT (assinado pelo servidor, seguro)
    let id_bpo = getIdBpoFromToken(token);

    // Fallback: buscar da API se não estiver no token
    if (id_bpo === null) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            id_bpo = data.id_bpo;
          }
        }
      } catch (error) {
        console.error('Erro ao verificar tipo de usuário:', error);
      }
    }

    // LÓGICA:
    // id_bpo === 0 ou null → Operador interno (acesso total)
    // id_bpo > 0 → Cliente (acesso restrito)
    const isClienteUsuario = id_bpo > 0;

    // Atualizar localStorage apenas para exibição
    localStorage.setItem('id_bpo', id_bpo);
    localStorage.setItem('isCliente', isClienteUsuario ? 'true' : 'false');

    setIsCliente(isClienteUsuario);
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="text-muted">Verificando acesso...</p>
        </div>
      </div>
    );
  }

  if (!token || !isTokenValid(token)) {
    localStorage.clear();
    // guarda para onde a pessoa ia (ex.: link do e-mail de finalização) — o
    // Login volta para cá depois de entrar, em vez de cair na página inicial.
    // sessionStorage: sobrevive ao localStorage.clear() acima e some ao fechar a aba.
    try {
      const destino = `${location.pathname}${location.search}`;
      if (destino && destino !== '/' && !destino.startsWith('/login')) {
        sessionStorage.setItem('saber_voltar_para', destino);
      }
    } catch (e) { /* navegador sem storage: segue para o login */ }
    return <Navigate to="/login" replace />;
  }

  // Se é cliente (id_bpo > 0), bloqueia rotas internas
  if (isCliente) {
    console.log('Cliente tentando acessar rota interna:', location.pathname);
    return <Navigate to="/acesso-negado" state={{ from: location }} replace />;
  }

  // Usuário interno (id_bpo === 0 ou null)
  return <Outlet />;
};

export default PrivateRoute;